import React from 'react'
import { useNotifications } from '../contexts/NotificationContext'

const AlertBadge = ({ category, className = '' }) => {
  const { notifications } = useNotifications()
  
  const categoryNotifications = notifications.filter(n => 
    !n.read && 
    (!category || n.category === category)
  )
  
  const criticalCount = categoryNotifications.filter(n => n.priority === 'critical').length
  const totalCount = categoryNotifications.length

  if (totalCount === 0) return null

  return (
    <span className={`position-relative ${className}`}>
      <span 
        className={`position-absolute top-0 start-100 translate-middle badge rounded-pill ${
          criticalCount > 0 ? 'bg-danger' : 'bg-warning'
        }`}
        style={{
          fontSize: '0.6rem',
          minWidth: '18px',
          height: '18px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {totalCount > 99 ? '99+' : totalCount}
        <span className="visually-hidden">unread notifications</span>
      </span>
      {criticalCount > 0 && (
        <span 
          className="position-absolute top-0 start-100 translate-middle pulse-animation"
          style={{
            width: '8px',
            height: '8px',
            background: '#dc3545',
            borderRadius: '50%',
            marginTop: '-2px',
            marginLeft: '2px'
          }}
        ></span>
      )}
    </span>
  )
}

export default AlertBadge